import { ObjectId } from 'mongodb';

import { IPaginationParamsQuery } from '@shared/interfaces';
export * from './lib/el-async-autocomplete.module';

/**
 * This enum stands for defining the autocomplete selection mode.
 * @param PLAIN mode can be used as text based selection mode.
 * @param CHIPS mode can be used as chips based selection mode.
 * @since 1.0.0
 */
export enum SELECTION_MODE {
  PLAIN = 'PLAIN',
  CHIPS = 'CHIPS',
}

export interface IELAsyncAutocompleteElement {
  key: string | ObjectId;
  value: string;
  disable?: boolean;
  avatar?: string;
}

export interface IRequestEvent extends IPaginationParamsQuery {
  type: 'typing' | 'scroll';
  event: string;
}
